import { ClientBase } from "./base.js";
import { DineClient } from "./dine.js";
/** Repair orders (orders.kind=service): /v1/sites/{slug}/repair-orders. */
export class RepairClient extends DineClient {
    repairBase(slug) {
        return `${this.siteBase(slug)}/repair-orders`;
    }
    /** business:write. */
    async createRepairOrder(slug, input) {
        return this.request("POST", this.repairBase(slug), input, true);
    }
    /** Archive search (business:read). `from`/`to` accept RFC 3339 or YYYY-MM-DD. */
    async listRepairOrders(slug, params = {}) {
        const res = await this.request("GET", `${this.repairBase(slug)}${ClientBase.query({
            q: params.q,
            vehicleId: params.vehicleId,
            from: params.from,
            to: params.to,
            includeVoided: params.includeVoided ? "true" : undefined,
            limit: params.limit,
            offset: params.offset,
        })}`, undefined, true);
        return res.repairOrders;
    }
    /** Non-voided order counts per UTC day for `month` (YYYY-MM). */
    async getRepairOrderCalendar(slug, month) {
        const res = await this.request("GET", `${this.repairBase(slug)}/calendar${ClientBase.query({ month })}`, undefined, true);
        return res.days;
    }
    /** Revenue / cost report; needs costs:read (403 otherwise). */
    async getRepairShopCosts(slug, params = {}) {
        return this.request("GET", `${this.repairBase(slug)}/shop-costs${ClientBase.query({ from: params.from, to: params.to })}`, undefined, true);
    }
    async getRepairOrder(slug, id) {
        return this.request("GET", `${this.repairBase(slug)}/${encodeURIComponent(id)}`, undefined, true);
    }
    /** `updatedAt` is required; 409 `stale_update` when changed, 409 `voided` when voided. */
    async patchRepairOrder(slug, id, input) {
        return this.request("PATCH", `${this.repairBase(slug)}/${encodeURIComponent(id)}`, input, true);
    }
    async voidRepairOrder(slug, id, reason) {
        return this.request("POST", `${this.repairBase(slug)}/${encodeURIComponent(id)}/void`, { reason }, true);
    }
    async restoreRepairOrder(slug, id) {
        return this.request("POST", `${this.repairBase(slug)}/${encodeURIComponent(id)}/restore`, undefined, true);
    }
}
//# sourceMappingURL=repair.js.map